import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ScaleState } from '../../interfaces/states/ScaleState';
import { ScaleStatus } from '../../../devices/device-enums';

export const initialState: ScaleState = {
  status: ScaleStatus.NOT_READY,
  weight: 0,
  weightUnit: '',
};

class ScaleReducer extends ImmerReducer<ScaleState> {
  public setScaleData(data: ScaleState) {
    this.draftState = data;
  }

  public setScaleStatus(status: ScaleStatus): void {
    this.draftState = { ...this.draftState, status };
  }

  public setScaleWeight(weight: number): void {
    this.draftState = { ...this.draftState, weight };
  }
  public setWeightUnit(weightUnit: string): void {
    this.draftState = { ...this.draftState, weightUnit };
  }

  public setMaxWeight(maxWeight: number): void {
    this.draftState = { ...this.draftState, maxWeight };
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const ScaleActions = createActionCreators(ScaleReducer);
export const ScaleReducerFunction = createReducerFunction(ScaleReducer, initialState);
